module.exports = __webpack_public_path__ + "static/gif4.7b24e122.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/dtgif/gif4.gif
// module id = 542
// module chunks = 270958380025928